import type { CameraContext, FlexCameraSummary, FlexPreset, FlexScheduleSummary } from "./types";

/** Stable references for Zustand selectors when `showFlexIgnoreZones` is false (avoid subscribing to flex IZ state). */
export const FLEX_IZ_LD_EMPTY_ENABLED_BY_SITE: Record<number, boolean> = {};
export const FLEX_IZ_LD_EMPTY_SYNC_LOADING: Record<number, boolean> = {};
export const FLEX_IZ_LD_EMPTY_PRESETS: Record<number, FlexPreset[]> = {};
export const FLEX_IZ_LD_EMPTY_PRESET_NAMES: Record<number, Record<number, string>> = {};
export const FLEX_IZ_LD_EMPTY_CAMERA_CONTEXTS: Record<number, CameraContext> = {};
export const FLEX_IZ_LD_EMPTY_SELECTED_CAMERAS: Record<number, number[]> = {};
export const FLEX_IZ_LD_EMPTY_PRESET_ASSIGNMENTS: Record<string, string> = {};
export const FLEX_IZ_LD_EMPTY_CAMERAS: FlexCameraSummary[] = [];
export const FLEX_IZ_LD_EMPTY_SCHEDULES: FlexScheduleSummary[] = [];

/** Stable empty list for `presetsByCamera[cameraId] ?? …` (avoids new `[]` each render). */
export const EMPTY_FLEX_PRESETS_LIST: FlexPreset[] = [];

export async function flexIgnoreZonesNoopLoadCameraContext(): Promise<void> {}
